// extracted by mini-css-extract-plugin
export default {"root":"Agreement_root__EfBOQ","title":"Agreement_title__Jxgtn","agreedTermSection":"Agreement_agreedTermSection__6Pzgb","partiesSection":"Agreement_partiesSection__QC0zQ"};